import edgehighlightVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edgehighlighted.vertex.glsl';
import edgehighlightFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edgehighlighted.fragment.glsl';
import arrowVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/arrow.vertex.glsl';
import arrowFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/arrow.fragment.glsl';
import radialaxesVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/radial-axis.vertex.glsl';
import radialaxesFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/radial-axis.fragment.glsl';
import arrowhighlightVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/arrowhighlighted.vertex.glsl';
import arrowhighlightFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/arrowhighlighted.fragment.glsl';
import edgesVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edge.vertex.glsl';
import edgesFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edge.fragment.glsl';
import midedgesVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedge.vertex.glsl';
import midedgesFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedge.fragment.glsl';
import midedgeculledVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedgeculled.vertex.glsl';
import midedgeculledFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedgeculled.fragment.glsl';
//shaders assembled with their shared dependency chunks (see shaders/glsl.ts)
import assembledShaders from '../../shaders/glsl.ts';
const { edgesdfVertex, edgesdfpickingVertex, edgesdfarrowVertex,
        edgesdfFragment, edgesdfpickingFragment,
        pointculledVertex, pointpickingVertex,
        pointselectedVertex, pointhighlightVertex } = assembledShaders;
import edgesdfarrowFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edgesdfarrow.fragment.glsl';
import pointdepthFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/pointdepth.fragment.glsl';
import edgeselectedVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedgeselected.vertex.glsl';
import edgeselectedFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midedgeculled.fragment.glsl';
import edgepickingVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edgepicking.vertex.glsl';
import edgepickingFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/edgepicking.fragment.glsl';
import pointpickingFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/pointpicking.fragment.glsl';
import pointculledFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/pointculled.fragment.glsl';
import pointhighlightFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/pointculled.fragment.glsl';
import pointselectedFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/pointculled.fragment.glsl';
import pointsVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/point.vertex.glsl';
import pointsFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/point.fragment.glsl';
import midpointsVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midpoint.vertex.glsl';
import midpointsFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/midpoint.fragment.glsl';
import fullscreenVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/fullscreen.vertex.glsl';
import fullscreenFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/fullscreen.fragment.glsl';
import fullscreenDarkVertex from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/fullscreendark.vertex.glsl';
import fullscreenDarkFragment from '!raw-loader!glslify-loader!@graphistry/viz/src/shaders/fullscreendark.fragment.glsl';

//every position-fed program samples the same node-position data texture
const nodePositionTextures = ['nodePositionTexture'];

export const programs = {
    edgehighlight: {
        sources: {
            vertex: edgehighlightVertex,
            fragment: edgehighlightFragment
        },
        attributes: ['curPos'],
        camera: 'mvp',
        uniforms: []
    },
    arrow: {
        sources: {
            vertex: arrowVertex,
            fragment: arrowFragment
        },
        attributes: ['startPos', 'endPos', 'normalDir', 'arrowColor', 'pointSize'],
        camera: 'mvp',
        uniforms: [
            'zoomScalingFactor',
            'maxPointSize',
            'maxScreenSize',
            'maxCanvasSize',
            'edgeOpacity'
        ]
    },
    radialaxes: {
        sources: {
            vertex: radialaxesVertex,
            fragment: radialaxesFragment
        },
        attributes: ['aPos', 'aCenter', 'aRadius'],
        camera: 'mvp',
        uniforms: []
    },
    arrowhighlight: {
        sources: {
            vertex: arrowhighlightVertex,
            fragment: arrowhighlightFragment
        },
        attributes: ['startPos', 'endPos', 'normalDir', 'pointSize', 'arrowColor'],
        camera: 'mvp',
        uniforms: ['zoomScalingFactor', 'maxPointSize', 'maxScreenSize', 'maxCanvasSize']
    },
    edges: {
        sources: {
            vertex: edgesVertex,
            fragment: edgesFragment
        },
        attributes: ['edgeColor', 'curPos'],
        camera: 'mvp',
        uniforms: []
    },
    midedges: {
        sources: {
            vertex: midedgesVertex,
            fragment: midedgesFragment
        },
        attributes: ['curPos'],
        camera: 'mvp',
        uniforms: []
    },
    midedgeculled: {
        sources: {
            vertex: midedgeculledVertex,
            fragment: midedgeculledFragment
        },
        attributes: ['curPos', 'edgeColor', 'startPos', 'endPos'],
        camera: 'mvp',
        uniforms: ['edgeOpacity', 'isOpaque']
    },
    edgesdf: {
        sources: {
            vertex: edgesdfVertex,
            fragment: edgesdfFragment
        },
        attributes: [
            'stripCoord', 'srcNodeId', 'dstNodeId',
            'srcColor', 'dstColor', 'shapeFactor', 'dstPointSize'
        ],
        camera: 'mvp',
        uniforms: [
            'edgeOpacity',
            'depthOcclusion', //motion-only inter-edge occlusion (prepareFrame)
            'depthIdMax',
            'edgeZoomScalingFactor',
            'viewportSize',
            'zoomScalingFactor',
            'edgeCurvature',
            'minPointSize',
            'maxPointSize',
            'maxScreenSize',
            'arrowEdgeSegments',
            'showArrows',
            'minStrokeWidthPx',
            'widthFade'
        ],
        textures: nodePositionTextures
    },
    edgesdfpicking: {
        sources: {
            vertex: edgesdfpickingVertex,
            fragment: edgesdfpickingFragment
        },
        attributes: ['stripCoord', 'srcNodeId', 'dstNodeId', 'shapeFactor', 'dstPointSize'],
        camera: 'mvp',
        uniforms: [
            'edgeZoomScalingFactor',
            'viewportSize',
            'edgeCurvature',
            'pickMultiplier',
            'textureScalingFactor',
            'zoomScalingFactor',
            'minPointSize',
            'maxPointSize'
        ],
        textures: nodePositionTextures
    },
    edgesdfarrow: {
        sources: {
            vertex: edgesdfarrowVertex,
            fragment: edgesdfarrowFragment
        },
        attributes: [
            'normalDir', 'srcNodeId', 'dstNodeId',
            'dstColor', 'shapeFactor', 'dstPointSize'
        ],
        camera: 'mvp',
        uniforms: [
            'viewportSize',
            'zoomScalingFactor',
            'edgeCurvature',
            'maxPointSize',
            'minPointSize',
            'maxScreenSize',
            'edgeOpacity',
            'tintWhite',
            'arrowEdgeSegments',
            'edgeZoomScalingFactor'
        ],
        textures: nodePositionTextures
    },
    edgepicking: {
        sources: {
            vertex: edgepickingVertex,
            fragment: edgepickingFragment
        },
        attributes: ['curPos', 'edgeColor', 'startPos', 'endPos'],
        camera: 'mvp',
        uniforms: []
    },
    edgeselected: {
        sources: {
            vertex: edgeselectedVertex,
            fragment: edgeselectedFragment
        },
        attributes: ['curPos', 'edgeColor', 'startPos', 'endPos'],
        camera: 'mvp',
        uniforms: ['isOpaque']
    },
    //depth-only node-disc prepass (see items.js pointdepth): pointculled
    //vertex (same sizing/position/depth plane), core-only depth fragment
    pointdepth: {
        sources: {
            vertex: pointculledVertex,
            fragment: pointdepthFragment
        },
        attributes: ['pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: [
            'stroke',
            'zoomScalingFactor',
            'maxPointSize',
            'minPointSize',
            'pointOpacity'
        ],
        textures: nodePositionTextures
    },
    pointculled: {
        sources: {
            vertex: pointculledVertex,
            fragment: pointculledFragment
        },
        attributes: ['pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: [
            'fog',
            'stroke',
            'zoomScalingFactor',
            'maxPointSize',
            'minPointSize',
            'pointOpacity'
        ],
        textures: nodePositionTextures
    },
    pointhighlight: {
        sources: {
            vertex: pointhighlightVertex,
            fragment: pointhighlightFragment
        },
        attributes: ['nodeId', 'pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: [
            'fog',
            'stroke',
            'zoomScalingFactor',
            'maxPointSize',
            'minPointSize',
            'pointOpacity'
        ],
        textures: nodePositionTextures
    },
    pointselected: {
        sources: {
            vertex: pointselectedVertex,
            fragment: pointselectedFragment
        },
        attributes: ['nodeId', 'pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: [
            'fog',
            'stroke',
            'zoomScalingFactor',
            'maxPointSize',
            'minPointSize',
            'pointOpacity',
            'posOffset'
        ],
        textures: nodePositionTextures
    },
    points: {
        sources: {
            vertex: pointsVertex,
            fragment: pointsFragment
        },
        attributes: ['curPos', 'pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: ['zoomScalingFactor', 'textureScalingFactor', 'maxPointSize']
    },
    pointpicking: {
        sources: {
            vertex: pointpickingVertex,
            fragment: pointpickingFragment
        },
        attributes: ['pointSize', 'pointColor'],
        camera: 'mvp',
        uniforms: ['zoomScalingFactor', 'textureScalingFactor', 'maxPointSize'],
        textures: nodePositionTextures
    },
    midpoints: {
        sources: {
            vertex: midpointsVertex,
            fragment: midpointsFragment
        },
        attributes: ['curPos'],
        camera: 'mvp',
        uniforms: []
    },
    fullscreen: {
        sources: {
            vertex: fullscreenVertex,
            fragment: fullscreenFragment
        },
        attributes: ['vertexPosition'],
        camera: 'mvp',
        uniforms: [],
        textures: ['steadyStateTexture']
    },
    fullscreenDark: {
        sources: {
            vertex: fullscreenDarkVertex,
            fragment: fullscreenDarkFragment
        },
        attributes: ['vertexPosition'],
        camera: 'mvp',
        uniforms: [],
        textures: ['steadyStateTexture']
    }
};
